// Central place to import/replace visual assets.
// Replace these placeholders with exact images when you provide them.

// Project-specific images (provided by user)

// Generic building/hero image (kept for any remaining usages)
const building = "/images/about us image.jpg";
const worker = "/hero.png";

export const ASSETS = {
  worker,
  building,
};

export default ASSETS;
